import dispatcher from "../Dispatcher/Dispatcher";
import { EventEmitter } from "events";
import UserTourGuideConstants from "../Constants/UserTourConstants";

let result = null;

class UserTourGuid extends EventEmitter {
  emitChange(eventName) {
    this.emit(eventName);
  }

  getResult() {
    return result;
  }

  setResult(_result) {
    result = _result;
  }

  addChangeListener(eventName, callback) {
    this.on(eventName, callback);
  }

  removeChangeListener(eventName, callback) {
    this.removeListener(eventName, callback);
  }
  handleCallback(action) {
    switch (action.type) {
      case UserTourGuideConstants.DISABLE_TOUR_SUCESS:
        this.setResult(action.result);
        break;
      case UserTourGuideConstants.DISABLE_TOUR_FAILURE:
        this.setResult(action.result);
        break;
      default:
        break;
    }
    this.emitChange(action.type);
    return true;
  }
}

const userTourGuid = new UserTourGuid();
dispatcher.register(userTourGuid.handleCallback.bind(userTourGuid));
export default userTourGuid;
